import React from 'react'
import Branding from './Branding'
import PageSection from './PageSection'
import Compliance from './Compliance'
import Booking from './Booking'
import Footer from './Footer'
import Clients from './Clients'

import { AiFillMessage } from "react-icons/ai";
import { FaInbox,FaBrain,FaReply,FaRobot,FaAddressBook,FaUser ,FaUsers,FaUserTag } from "react-icons/fa";

import fs from "../../MessageImage/messagingoverview .png";
import oi from "../../MessageImage/omnichannelinbox.jpeg";
import cb from "../../MessageImage/chatbots.png";
import ms from '../../MarketingImages/customercontacts.jpeg';
import ps from "../../MessageImage/personalisation.png";
import es from "../../MessageImage/employeeassignment.png";
import tc from "../../MessageImage/teamchat.png";
import ar from "../../MessageImage/contactmanagement.jpeg";
import { useNavigate } from 'react-router-dom'



function Comms() {
  const navigate = useNavigate();
  const omnichannelInboxData = [
    {
      icon: <FaInbox />,
      iconTitle: 'Omnichannel Inbox',
      image: oi,
      title: 'Manage all your messages in one unified inbox for streamlined communication.',
      lines: [
        'Centralized view of messages from various communication channels.',
        'Efficiently respond to messages from a single dashboard.',
        'Improve response times and customer satisfaction.'
      ],
    },
  ];

  const nlpSegmentationData = [
    {
      icon: <FaBrain />,
      iconTitle: 'NLP Segmentation',
      title: 'Leverage Natural Language Processing to segment and analyze customer messages.',
      lines: [
        'Automatically categorize messages based on language and intent.',
        'Understand customer sentiments and emotions in real-time.',
        'Enhance personalized responses through advanced segmentation.'
      ],
    },
  ];
  const automatedResponsesData = [
    {
      icon: <FaReply />,
      iconTitle: 'Automated Responses',
      image: ar,
      title: 'Implement automated responses for quick and efficient customer engagement.',
      lines: [
        'Create predefined responses for frequently asked questions.',
        'Automate responses based on customer interactions and behavior.',
        'Improve efficiency and provide instant support to customers.'
      ],
    },
  ];
  
  const chatbotsData = [
    {
      icon: <FaRobot />,
      iconTitle: 'Chatbots',
      image: cb,
      title: 'Integrate AI-powered chatbots to enhance customer interactions and support.',
      lines: [
        'Implement chatbots for instant and personalized responses.',
        'Automate routine tasks and frequently asked questions.',
        'Provide 24/7 support and improve customer experiences.'
      ],
    },
  ];
  
  const contactManagementData = [
    {
      icon: <FaAddressBook />,
      iconTitle: 'Contact Management',
      image: ms,
      title: 'Efficiently manage and organize your contacts for targeted and personalized communication.',
      lines: [
        'Maintain a centralized database of customer contact information.',
        'Segment contacts based on messaging interactions and preferences.',
        'Enhance personalized messaging by leveraging accurate customer data.'
      ],
    },
  ];

  const personalizationData = [
    {
      icon: <FaUser />,
      iconTitle: 'Personalization',
      image: ps,
      title: 'Deliver personalized messaging experiences through targeted and relevant content.',
      lines: [
        'Tailor messages based on customer preferences and behaviors.',
        'Enhance engagement with personalized offers and recommendations.',
        'Create a unique and memorable customer journey.'
      ],
    },
  ];
  
  const teamChatData = [
    {
      icon: <FaUsers />,
      iconTitle: 'Team Chat',
      image: tc,
      title: 'Facilitate seamless communication and collaboration among your team members.',
      lines: [
        'Create dedicated chat channels for different teams and projects.',
        'Share information, updates, and files in real-time.',
        'Enhance team productivity and foster a collaborative work environment.'
      ],
    },
  ];
  
  const employeeAssignmentData = [
    {
      icon: <FaUserTag />,
      iconTitle: 'Employee Assignment',
      image: es,
      title: 'Streamline task assignments and communication within your team.',
      lines: [
        'Assign tasks and projects to specific team members.',
        'Track progress and completion of assignments.',
        'Facilitate efficient communication for successful project execution.'
      ],
    },
  ];
  
  
  return (
    <div className='pt-5  gap-[70px] flex flex-col items-center min-h-full w-full'>
    <div className='w-full flex justify-center bg-white sticky top-0 pt-5'>
        <div   className={` w-[78%]   flex  bg-white  pb-4 `}>    
            <div className='flex gap-2 items-center'>
                <div>
                <AiFillMessage  className='text-[30px] text-blue-600' />
                </div>
                <div className='flex flex-col'>
                    <span className='semibold text-[13px]'>Elyzian</span>
                    <span className='bold text-sm'>Messaging Management</span>

                </div>
            </div>
        </div>
  </div>

  {/* 1st Section */}

  <div   className="w-full sm:w-[90%] lg:w-[85%] 2xl:w-[78%] h-max lg:h-[620px] sm:mt-3  flex flex-col lg:flex-row gap-6 lg:gap-3   p-[5%] bg-[#fafafa] sm:rounded-[50px]">       
     <div className='w-full lg:w-[50%] flex flex-col gap-5 justify-start h-full'>
        <div>     
        <span className='bold text-[28px] lg:text-[32px] xl:text-[38px] 2xl:text-[44px]   sm:leading-[45px] xl:leading-[55px] 2xl:leading-[65px]'>From Unified Inboxes to AI Chatbots : Master Your Messaging Realm</span>    
</div>
       
        <span className='regular  text-sm sm:text-base lg:text-[18px] 2xl:text-[20px] leading-[26px] lg:leading-[36px]  '> Manage messages from various channels, implement AI-powered chatbots for instant responses, and utilize NLP segmentation for personalized customer interactions. Enhance team collaboration with team chat and efficient task assignment.
        </span>
        
            
            <button onClick={() => navigate('/waitlist')} className="flex items-center gap-2 text-sm w-max  sm:text-[14px]  tracking-wide rounded-lg hover:shadow hover:bg-[#1e46f6f6] hover:ring-[2px] hover:ring-blue-200 bold px-3 py-2 sm:px-5 border sm:p-[12px] bg-[#1e47f6] border-[#1e47f6] text-white hover:transition hover:delay-200">
<span className="button-content medium">Get Started Free</span>
</button>
     </div>
     <div className=' lg:flex lg:justify-center  w-full lg:w-[50%]'>
     <img className='sm:h-[470px] aspect-auto rounded-2xl' src={fs} alt="" />
     </div>
  </div>

  {/* 2nd Section */}
        <Clients />

        {/* 3rd Section */}
        {/* <div  className="w-[90%] lg:w-[85%] 2xl:w-[78%] flex flex-col gap-10 mt-24 items-center">       
<span className='bold text-center  text-[20px] sm:text-[24px] lg:text-[30px]'>Why does business management matter?</span>
<div className=' flex flex-wrap xl:flex-nowrap gap-4 justify-evenly w-full'>
 {reviewCard?.map((e) => (
    <div className="w-[380px] h-[400px] border rounded-[30px] shadow-md bg-[#fafafa] flex flex-col gap-5 p-6">
    <span className="text-2xl xl:text-3xl 2xl:text-5xl text-blue-700"> {e.icon}</span>
    <span className='bold text-[17px] xl:text-[20px]  '>{e.title}</span>    
        
         <span className='regular text-sm lg:text-base leading-[25px] lg:leading-[30px] break-words  '>{e.sub}</span>
    </div>
 ))}
   

</div>
</div> */}
  {/* 4th Section */}
  <PageSection bg  data={omnichannelInboxData} />

  <PageSection reverse  data={nlpSegmentationData} />
  {/* <Clients /> */}

  <PageSection bg data={personalizationData} />

  <PageSection   data={automatedResponsesData} />

  <PageSection bg  data={chatbotsData} />

  <PageSection reverse  data={contactManagementData} />

  <PageSection bg data={employeeAssignmentData} />


  <Branding />

  <PageSection bg reverse data={teamChatData} />

  <Compliance />

  <Booking />

  <Footer />






</div>
  )
}

export default Comms
